import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';
import {
  GlobalSearchRequest,
  GlobalSearchResult
} from '../types/global-search-types';

export class GlobalSearch extends BaseOrganizationEndpoints {
  async search(
    params: GlobalSearchRequest
  ): Promise<ResponseWithStatus<GlobalSearchResult>> {
    return this.requestWithStatus<GlobalSearchResult>('POST', '/v1/search', params);
  }
}

